<template>
  <container>
    <tooltip-title>{{ title }}</tooltip-title>
    <tooltip-value>{{ value }}</tooltip-value>
  </container>
</template>

<script>
import { Container, TooltipTitle, TooltipValue } from './tileTooltip.styles';
import { orderOfMagnitude } from '../../../../utils/formatNumbers';

export default {
  components: { Container, TooltipTitle, TooltipValue },
  props: {
    data: Object,
  },
  computed: {
    title() {
      return this.data.label;
    },
    value() {
      return this.data.value ? orderOfMagnitude(this.data.value) : 'No data';
    },
  },
};
</script>
